export default "__VITE_ASSET__nh6Ss6XE__"